<template lang="pug">
  .stats-group
    .stats-group-indicator(v-if="indicator")
      span.stats-group-dot(:class="dotClass")
      span.stats-group-indicator-text {{ indicator }}

    .stats-group-value-row
      .stats-group-value {{ value }}
      .stats-group-label(:title="label")
        | {{ label }}
</template>

<script>
export default {
  name: 'InsightsUtilizationWidgetStatsGroup',
  props: {
    indicator: { type: String, default: '' }, // 'Remote'/'Office' etc.
    indicatorVariant: { type: String, default: '' }, // remote | office
    value: { type: String, required: true },
    label: { type: String, required: true },
  },
  computed: {
    dotClass() {
      return this.indicatorVariant ? `stats-group-dot-${this.indicatorVariant}` : '';
    },
  },
};
</script>
